import React, { useState, useEffect } from 'react';
import './Card.css';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import cardImage from './card_img.png';

function MyVerticallyCenteredModal(props) {
  const { result, onHide, showpenaltymessage } = props;

const cardImageUrl = result.combine_flag === 1 && result.hint
    ? `${process.env.PUBLIC_URL}/images/se-spiel/${result.hint}.png`
    : './card_img.png'; 
  
  return (
    <Modal
      {...props}
      size='xl'
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
           Ergebnis
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <Row>
          <Col className='text-justify' sm={9}>
        <div className="card-info">
          Karte {result.card1}: {result.card1_name} + Karte {result.card2}: {result.card2_name}
        </div>

        <div className="card-info">
          <span className="feedback">Feedback: </span>
          {result.feedback}
        </div>

        {result.combine_flag === 1 && (
          <>
            {result.hint && (
              <div className="card-info">
                <span className="hint">Neue Methodenkarte: </span>
                {result.hint}
              </div>
            )}
            {result.remove_card && (
              <div className="card-info">
                <span className="hint">Zu Entfernende Methodenkarte: </span>
                {result.remove_card} 
                <p>Diese Karte kann in der App nicht mehr ausgewählt werden.</p>
              </div>
            )}
          </>
        )}
        
        {showpenaltymessage && (
          <div className="card-info">
            <span className="hint" style={{ color: 'red' }}>
              Strafe für falsche Kombination: 20 Sekunden werden von Ihrer Zeit abgezogen.
            </span>
          </div>
        )}

        </Col>
          <Col className='text-center' sm={3}>
          
       

{result.combine_flag === 1 && result.hint !== "" && (
              <div>
                <img className='img-fluid' src={cardImageUrl} alt="Card" />
              </div>
            )}


          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{ backgroundColor: "#009374" , outline: "none", border: "none" }} onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function Card({ name, number, isSelected, isClickable, handleClick, removeCard }) {
  return (
    <div
      className={`card ${isSelected ? 'selected' : ''} ${
        isClickable ? '' : 'non-clickable'
      }`}
      onClick={isClickable ? () => handleClick(number) : null}
    >
      <div className="card-body">
          <h5 className="card-title">Karte {number}:</h5>
          <p className="card-text">{name}</p>
      </div>

    </div>
  );
}

function CardRow({ removeCard, setRemoveCard, prevTime, setPrevTime }) {
  const [selectedCards, setSelectedCards] = useState([]);
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [showpenaltymessage, setShowPenaltyMessage] = useState(false);
  const [result, setResult] = useState({});
  const [data, setData] = useState([]);

  const handleCardClick = (cardNumber) => {
    if (selectedCards.includes(cardNumber)) {
      setSelectedCards((prevSelectedCards) =>
        prevSelectedCards.filter((number) => number !== cardNumber)
      );
    } else if (selectedCards.length < 2 && !removeCard.includes(cardNumber)) {
      setSelectedCards((prevSelectedCards) => [
        ...prevSelectedCards,
        cardNumber,
      ]);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const requestData = {
      card1: selectedCards[0],
      card2: selectedCards[1],
    };

    fetch(`${process.env.REACT_APP_API_URL}/combination`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        setResult(data);
        setShowResultPopup(true);
        setRemoveCard((prevRemoveCard) => [...prevRemoveCard, data.remove_card]);
        if (data.combine_flag !== 1) {
          setPrevTime((prevTime) => prevTime - 20);
          setShowPenaltyMessage(true);
        }
      })
      .catch((error) => console.error(error));
  };

  const handleModalClose = () => {
    setSelectedCards([]);
    setResult({});
    setShowResultPopup(false);
    setShowPenaltyMessage(false);
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/cards`)
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);

  return (
    <div className="card-row">
      <Row>
        {data.map((item) => (
          <Col key={item.id} className='col-6 col-sm-6 col-md-4 col-lg-2 col-xl-2'>
            <Card
              name = {item.card_name}
              number={item.id}
              isSelected={selectedCards.includes(item.id)}
              isClickable={!removeCard.includes(item.id)}
              handleClick={handleCardClick}
              removeCard={removeCard}
            />
          </Col>
        ))}
      </Row>

      {!showResultPopup && (
      <button
        type="submit"
        onClick={handleSubmit}
        disabled={selectedCards.length !== 2}
      >
        Kombinieren
      </button>
      )}


      <MyVerticallyCenteredModal
        show={showResultPopup}
        onHide={handleModalClose}
        result={result}
        showpenaltymessage={showpenaltymessage}
      />
    </div>
  );
}

export default CardRow;
